var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {}, [
      _c(
        "ul",
        { staticClass: "nav nav-tabs" },
        _vm._l(_vm.tabs, function(item) {
          return _c(
            "li",
            { key: item.id, staticClass: "nav-item" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: { name: "Salemon Agent", params: { tab: item.id } }
                  }
                },
                [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flexbox" },
        _vm._l(_vm.tabs, function(item) {
          return _c("label", {
            key: item.id,
            staticClass: "line",
            class: { active: _vm.tab === item.id }
          })
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ae2e253", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae2e253","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/salemonAgent/NavTabs.vue
// module id = null
// module chunks = 